import { createFileRoute } from "@tanstack/react-router";

import { PartnersPage } from "@/features/administration/pages";

/** The partners as hg-auth has them: the section's to read, a superadmin's to switch. */
export const Route = createFileRoute("/_app/settings/partners")({
  component: PartnersPage,
});
